import { useQuery } from '@tanstack/react-query';
import { fetchCases } from '../api/cases';

/**
 * Fetches the list of cases with optional filters.
 * @param {Object} filters - { status?, risk_level?, assigned_to?, limit?, offset? }
 */
export const useCases = (filters = {}) => {
  return useQuery({
    queryKey: ['cases', filters],
    queryFn: () => fetchCases(filters),
    staleTime: 30_000, // 30s
  });
};
